import React, { Component } from 'react';
import { connect } from 'react-redux';
import Donut from "../../Doughnut/index";
import { getUtfalldiagramBMByAfid,setofUpdatedashboardBokaTV } from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import {format}  from 'date-fns';
import {Grid} from '@material-ui/core'
import { sv } from "date-fns/locale";
import BackGroupChart from '../../../DashboardSälj/Inputs/ExtraLarge/BackGroupChart'
import IntlMessages from 'util/IntlMessages';
import Skeleton from '@material-ui/lab/Skeleton';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboardBokaTY} = accountsData
    const { UtfallBMdiagram,DashboardBokaFilterOption} = DashBoard;
    return {
        authUser,UtfallBMdiagram,DashboardBokaFilterOption,updatedashboardBokaTY
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getUtfalldiagramBMByAfid: (Afid,userid,FilterOption) => dispatch(getUtfalldiagramBMByAfid(Afid,userid,FilterOption)),
        setofUpdatedashboardBokaTV: () => dispatch(setofUpdatedashboardBokaTV()),
        dispatch
    };
}

class ExtraLargeProgress extends Component {
    state={
        UtfallBMdiagram:!isUndefined(this.props.UtfallBMdiagram)?this.props.UtfallBMdiagram:{utfall:0,budget:100},
        DashboardBokaFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getUtfalldiagramBMByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })          
    }
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({done: false,})
                    const Afid = this.props.Afid;
                    this.props.getUtfalldiagramBMByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            180000
        );
      }
    componentDidUpdate=()=>{
        const Afid = this.props.Afid;
        if(parseInt(this.props.updatedashboardBokaTY) === 1){
            this.props.getUtfalldiagramBMByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             })
            this.props.setofUpdatedashboardBokaTV()
        }
        if(this.props.DashboardBokaFilterOption !== this.state.DashboardBokaFilterOption && !isEmpty(this.props.DashboardBokaFilterOption))
           {
                
            this.setState({done:false})
               this.props.getUtfalldiagramBMByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) /**/
               this.setState({
                DashboardBokaFilterOption:this.props.DashboardBokaFilterOption 
               }) 
           }
      
        if(!isUndefined(this.props.UtfallBMdiagram)){
            if(this.props.UtfallBMdiagram !== this.state.UtfallBMdiagram){
                this.setState({
                    UtfallBMdiagram:this.props.UtfallBMdiagram
                })
            }
        }
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }
    formatNumber=(number)=>{
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return parseInt(number)
        }
    }
    
    render() {
        return (
            <>
        
            <div className="jr-card jr-card-full m-0" style={{ backgroundColor: 'transparent' }}>
           <div
                   className={
                       `jr-fillchart jr-overlay-fillchart`
                   }
                   style={{ backgroundColor: 'transparent' }}
               >  
           <BackGroupChart height={this.props.height}/>
            </div>
           
            <div className="jr-fillchart-content">
            <div className="text-center text-white">
               <h2 style={{ margin: '0',fontSize:"20px" }}><b><IntlMessages id="Outcome.Budget"/></b></h2>
               <p style={{fontSize:"14px",textTransform:"capitalize"}}>{`${format(new Date(), 'MMMM', { locale: sv })}`}</p>
           </div>
           <div>
           <Grid
           container
           direction="row"
           >
               {
                 this.state.done === false?  
                 <Skeleton variant="rectangular" height={120}style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                 :
                   this.props.isFrom === 1 ?
                    <Grid item xs={12} style={{ marginTop: '-0.5rem', textAlign: 'center' }}>
                        <span style={{ fontSize: 55,color:"#fff"}}>
                        {
                        (parseInt(this.state.UtfallBMdiagram.budget) === 0?0:
                            parseInt(this.state.UtfallBMdiagram.utfall)/parseInt(this.state.UtfallBMdiagram.budget) * 100).toFixed(0)
                        }</span>
                        <span style={{ fontSize: 20,color:"#fff"}}>%</span>
                    </Grid>
                   :
                   <Grid item xs={12} style={{ marginTop: '-1.5rem', textAlign: 'center' }}>
                        <span style={{ fontSize: 100,color:"#fff"}}>
                        {
                        (parseInt(this.state.UtfallBMdiagram.budget) === 0?0:
                            parseInt(this.state.UtfallBMdiagram.utfall)/parseInt(this.state.UtfallBMdiagram.budget) * 100).toFixed(0)
                        }</span>
                        <span style={{ fontSize: 35,color:"#fff"}}>%</span>
                    </Grid>
               }
               <Grid item xs={12}>
               {
              this.state.done === false?  
              <Skeleton variant="rectangular" height={40} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
              :
               <Grid
               container
               direction="row"
               justify="space-between"
               alignItems="center"
               >
               <span style={{ color:"#fff"}}>
                   {isEmpty(this.state.UtfallBMdiagram)?"":
                    parseInt(this.props.Flags.DashboardBokaFormat) === 0 ?
                   <>
                   <p className="m-0 p-0" style={{fontSize:14}}><IntlMessages id="input.type.Outcome"/></p>
                   <p className="m-0 p-0" style={{fontSize: this.props.isFrom === 1 ? 18 : 25}}>
                       {this.state.UtfallBMdiagram.utfall}
                   </p>
                   </> : ''
                   } </span>
               <span style={{ fontSize: 20,color:"#fff"}}>
                   {
                   isEmpty(this.state.UtfallBMdiagram)?"":
                   parseInt(this.props.Flags.DashboardBokaFormat) === 0 ?
                   <>
                   <p className="m-0 p-0" style={{fontSize:14}}><IntlMessages id="Budget.Label"/></p>
                   <p className="m-0 p-0" style={{fontSize: this.props.isFrom === 1 ? 18 : 25}}>
                       {this.formatNumber(this.state.UtfallBMdiagram.budget)}
                   </p>
                   </> : ''
                   }</span>
               </Grid>
    }
               </Grid>
           </Grid>
           </div>
            
       </div>
       </div>
           </>
           
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(ExtraLargeProgress);

